// extracted by mini-css-extract-plugin
export var apiV2Limits = "api-v2-limits_RWGjSutTz4R4GNpELfbA";